import React, { Suspense } from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import ClientRoutes from './components/Clients/ClientRoutes';
import TaskRoutes from './components/Tasks/TaskRoutes';
import Home from './components/Home';
import AddUser from './components/Clients/Users/AddUser';
import AppContainer from './components/Common/AppContainer';
import NotificationBoundary from './components/Common/NotificationBoundary';
import Login from './pages/Auth/Login';
import JobRoutes from './components/Jobs/JobRoutes';
// const Tasks = React.lazy(() => import('./components/Tasks'));

const Router = () => {
  return (
    <HashRouter>
      <Suspense fallback={<div>is Loading...</div>}>
        <Switch>
          <Route path="/auth" exact component={Login} />
          <AppContainer>
            <Route path="/tasks" component={TaskRoutes} />
            <Route path="/jobs" component={JobRoutes} />
            <Route path="/clients" component={ClientRoutes} />
            <Route path="/users/add" exact component={AddUser} />
            <Route path="/" exact component={Home} />
            <NotificationBoundary />
          </AppContainer>
        </Switch>
      </Suspense>
    </HashRouter>
  );
};

export default Router;
